import template from './swag-cms-extensions-form-editor-settings-field-type-number.html.twig';
import './swag-cms-extensions-form-editor-settings-field-type-number.scss';

const { Component } = Shopware;

Component.extend('swag-cms-extensions-form-editor-settings-field-type-number',
    'swag-cms-extensions-form-editor-settings-field-type-base',
    {
        name: 'swag-cms-extensions-form-editor-settings-field-type-number',

        template,

        computed: {
            min: {
                set(newMin) {
                    Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                        this.field.id,
                        'min',
                        newMin,
                    );
                },

                get() {
                    return this.field?.translated?.config?.min ?? this.field?.config?.min;
                },
            },

            max: {
                set(newMax) {
                    Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                        this.field.id,
                        'max',
                        newMax,
                    );
                },

                get() {
                    return this.field?.translated?.config?.max ?? this.field?.config?.max;
                },
            },

            step: {
                set(newStep) {
                    Shopware.Store.get('swCmsDetailCurrentCustomForm').setFieldConfigProperty(
                        this.field.id,
                        'step',
                        newStep,
                    );
                },

                get() {
                    return this.field?.translated?.config?.step ?? this.field?.config?.step ?? 1;
                },
            },
        },
    });
